<product-card class="d-block px-3 py-3 py-sm-1"
              (click)="onProductTypeClick($event)"
              [ngClass]="{
                'py-3': uiContext.isXs() || !!currentLines?.length,
                'py-sm-1': !uiContext.isXs() && !currentLines?.length,
                'cart-line-in-cart': !!currentLines?.length
              }">
  @if (showImage && !!productType.image) {
    <product-image class="me-3"
                   data-modal-ignore
                   [imagePreviewTrigger]="productType.image.original">
      <img [src]="productType.image.small" [alt]="productType.name">
    </product-image>
  }

  <product-header class="d-flex justify-content-between align-items-start">
    <div class="fw-bold w-60">{{ productType.name }}</div>

    @if (!currentLines?.length) {
      <button class="pointer btn-primary-themed add-to-cart-btn"
              data-modal-ignore
              (click)="onShowModal()">
        <i class="icon-plus add-to-cart-icon"></i>
      </button>
    }
  </product-header>

  @if (!!currentLines?.length) {
    <product-counter data-modal-ignore>
      <product-cart-actions
        actions
        [buildsCount]="buildsCount"
        [showEdit]="buildsCount === 1"
        [showAddNew]="true"
        (edit)="onEdit()"
        (addNew)="onShowModal()"
        (showCart)="onShowCart()"
      ></product-cart-actions>
    </product-counter>
  }

  <product-description [class.small-description]="showImage && !!productType.image">
    @if (!uiContext.isXs()) {
      <div class="font-sm text-muted"
           [innerHTML]="productType?.description">
      </div>
    } @else {
      <product-description-slice
        class="font-sm text-muted"
        [lines]="2"
        [text]="productType?.description"
      ></product-description-slice>
    }
    <!-- several menus: the cart lists each one, the row only says how many -->
    @if (buildsCount < 2) {
      @for (build of menuBuilds; track build.line.orderLineBuilderId) {
        <div class="border-top mt-2 pt-2" data-modal-ignore>
          <menu-chosen-products [menuChosenProducts]="build.products"></menu-chosen-products>
          <div class="full-price fw-bold mb-1">
            {{ build.fullPrice | currencyFormat: productType?.bakery?.country?.currencySymbol }}
          </div>
        </div>
      }
    }
  </product-description>
</product-card>
